module.exports = __webpack_public_path__ + "static/media/icon-dropdown-arrow-filled.b7e13730.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-dropdown-arrow-filled.svg
// module id = 687
// module chunks = 0